import { render, staticRenderFns } from "./AtomEscalationAvatar.vue?vue&type=template&id=5b9e93ad&scoped=true&"
import script from "./AtomEscalationAvatar.vue?vue&type=script&lang=js&"
export * from "./AtomEscalationAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AtomEscalationAvatar.vue?vue&type=style&index=0&id=5b9e93ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e93ad",
  null
  
)

export default component.exports